// extracted by mini-css-extract-plugin
export default {"cls1":"g7HTQk1Je6EgepN35rOu","cls2":"WrGTxrYrO_ZXrtEA19x4 g7HTQk1Je6EgepN35rOu"};